import React from "react";

import destination_1 from "../../public/wheretogo-beskydy/lysahora/destination_1.png"
import destination_2 from "../../public/wheretogo-beskydy/lysahora/destination_2.png"
import destination_3 from "../../public/wheretogo-beskydy/lysahora/destination_3.png"
import destination_4 from "../../public/wheretogo-beskydy/lysahora/destination_4.png"
import destination_5 from "../../public/wheretogo-beskydy/lysahora/destination_5.png"

import destinationIcon_1 from "../../public/wheretogo-beskydy/lysahora/icon_1.png"
import destinationIcon_2 from "../../public/wheretogo-beskydy/lysahora/icon_2.png"
import destinationIcon_3 from "../../public/wheretogo-beskydy/lysahora/icon_3.png"
import destinationIcon_4 from "../../public/wheretogo-beskydy/lysahora/icon_4.png"


import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider"


const LysaHora = () => {

  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? 'dark' : 'light'}`}>
        <div className="container">
          <div className="destinations__container">
            <img
              src={destination_1}
              alt=""
            />
            <h1>Lysá Hora</h1>
              {/* <Link className="destinations__maps" to="/">
                <img src={ShowOnMaps} alt="" />
                Zobrazit na mapě
              </Link> */}
            <p>
              Lysá hora je nejvyšším vrcholem Moravskoslezských Beskyd. Lze na
              ní přijít pěšky, vyšlapat na kole a za dobrých sněhových podmínek
              vyjet na běžkách. Leží mezi obcemi Krásná, Malenovice, Ostravice a
              Staré Hamry. Samotnému vrcholu se přezdívá Gigula.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? 'dark' : 'light'}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img
                src={destinationIcon_1}
                alt=""
              />
              <p>vysílací věž</p>
            </div>
            <div className="destinations__icon">
              <img
                src={destinationIcon_2}
                alt=""
              />
              <p>turistická chata</p>
            </div>
            <div className="destinations__icon">
              <img
                src={destinationIcon_3}
                alt=""
              />
              <p>1323 m. n. m.</p>
            </div>
            <div className="destinations__icon">
              <img
                src={destinationIcon_4}
                alt=""
              />
              <p>horské kolo</p>
            </div>
          </div>
        </div>
      </section>

      <section className={`destinations__attractions ${darkMode ? 'dark' : 'light'}`}>
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img
                className="destination_1"
                src={destination_2}
                alt=""
              />
              <img
                className="destination_2"
                src={destination_3}
                alt=""
              />
              <img
                className="destination_3"
                src={destination_4}
                alt=""
              />
              <img
                className="destination_4"
                src={destination_5}
                alt=""
              />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Vrcholu již z velké dálky dominuje telekomunikační věž. Ta prý
                  měří 15x více než napadlo sněhu před první světovou válkou.{" "}
                </li>
                <li>
                  Pamětní deska připomíná památku padlých, popravených a
                  umučených turistů v letech 1938 – 1945
                </li>
                <li>
                  Hora je domovem vzácné flory a fauny: žije zde čáp černý, rys
                  ostrovid, holub doupňák a z rostlin jalovec, prstnatec
                  Fuchsův, okrotice bílá, vemeník dvoulistý, vstavač mužský a
                  bradáček vejčitý.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LysaHora;
